import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=95a2a996&scoped=true&"
import script from "./PromoCard.vue?vue&type=script&lang=js&"
export * from "./PromoCard.vue?vue&type=script&lang=js&"
import style0 from "./PromoCard.vue?vue&type=style&index=0&id=95a2a996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a2a996",
  null
  
)

export default component.exports